var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { E_INFO_MESSAGE_SEVERITY, InfoMessage } from 'src/ui/components/InfoMessage/InfoMessage';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import { ResultMessages } from 'src/ui/views/users/components/UsersImportModal/components/ResultMessages/ResultMessages';
/**
 *
 * Successful import is organized as follows:
 * Success message
 * warning if some alert detected
 * global messages
 * user messages
 *
 */
export var SuccessfulImport = function (props) {
    var i18n = props.i18n, info = props.info, nbOfUsers = props.nbOfUsers, nbOfCreatedUsers = props.nbOfCreatedUsers, nbOfUpdatedUsers = props.nbOfUpdatedUsers, globalMessages = props.globalMessages;
    var haveAlertMessages = info.some(function (userInfo) {
        return userInfo.messages.some(function (msg) { return msg.severity === E_INFO_MESSAGE_SEVERITY.WARNING || msg.severity === E_INFO_MESSAGE_SEVERITY.ERROR; });
    });
    var successMessage = getPropsByKeyPath(i18n, 'components.importUsersModal.results.success.mainMessage');
    var totalUserProcessedMessage = getPropsByKeyPath(i18n, 'components.importUsersModal.results.success.totalUserProcessed').replace('$nbOfUsers', nbOfUsers);
    var processedUserText = getPropsByKeyPath(i18n, 'components.importUsersModal.results.success.userProcessed').replace('$nbOfUsersCreated', nbOfCreatedUsers);
    var processedUserDetailsText = getPropsByKeyPath(i18n, 'components.importUsersModal.results.success.userProcessedDetails').replace('$nbOfUsersUpdated', nbOfUpdatedUsers);
    var warningTitle = getPropsByKeyPath(i18n, 'components.importUsersModal.results.success.warning.title');
    var warningMessage = getPropsByKeyPath(i18n, 'components.importUsersModal.results.success.warning.message');
    return (_jsxs(_Fragment, { children: [_jsx(InfoMessage, __assign({ severity: E_INFO_MESSAGE_SEVERITY.SUCCESS }, { children: _jsxs("p", { children: [_jsx("b", { children: successMessage }), _jsx("br", {}), _jsx("br", {}), _jsxs("span", { children: [totalUserProcessedMessage, " ", _jsx("strong", { children: processedUserText }), " ", processedUserDetailsText] })] }) })), haveAlertMessages && (_jsx(InfoMessage, __assign({ severity: E_INFO_MESSAGE_SEVERITY.WARNING }, { children: _jsxs("p", { children: [_jsx("b", { children: warningTitle }), _jsx("br", {}), _jsx("br", {}), _jsx("span", { children: warningMessage })] }) }))), _jsx(ResultMessages, { i18n: i18n, globalMessages: globalMessages, info: info })] }));
};
